import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const UserDetailsPage = lazy(() => import('./UserDetailsPage'));

const UserDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.UserManagement,
  routes: [
    {
      path: 'users/:id',
      element: <UserDetailsPage />,
    },
  ],
};

export default UserDetailsConfig;
